// extracted by mini-css-extract-plugin
export var sliderRange = "_lf-2";
export var sliderRoot = "_lf-0";
export var sliderThumb = "_lf-3";
export var sliderTrack = "_lf-1";